<template>
  <FormulateInput
    v-bind="field"
    v-model="computedValue"
    :fullObject="fullObject"
    @update:fullObject="$emit('update:fullObject', $event)"
  >
    <template #help>
      <label v-if="field.isRequired" class="mt-1 fst-italic">
        <span class="text-danger">*</span> {{ $t('report.filters.required') }}
      </label>
    </template>
  </FormulateInput>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    fullObject: {
      type: Array,
      default: () => [],
    },
    field: {
      type: Object,
      required: true,
    },
  },
  emits: ['input', 'update:fullObject'],

  computed: {
    computedValue: {
      get: function () {
        if (this.value === '' || this.value === false) return null
        return this.value
      },
      set: function (newValue) {
        if (newValue === '' || newValue === false) {
          this.$emit('input', null)
          return
        }

        this.$emit('input', newValue)
      },
    },
  },
}
</script>
